import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

import { StatisticsClickType, StatisticsBannerDataType, StatisticsPostType } from 'types/stats';

dayjs.extend(isBetween);

export const generalSummaryBanner = (
  statisticsData: StatisticsBannerDataType,
  startDate: dayjs.Dayjs | null,
  endDate: dayjs.Dayjs | null,
) => {
  const { channels, disabledFilter } = statisticsData;

  let totalParticipants = 0;
  let totalClicks = 0;
  let totalViews = 0;
  let totalPostsWithBanner = 0;
  let totalSell = 0;
  let totalPosts = 0;

  const isDateInRange = (date: string) => {
    return !startDate || !endDate || dayjs(date).isBetween(startDate, endDate, 'day', '[]');
  };

  const filterPosts = (posts: StatisticsPostType[]) => {
    return posts.filter((post) => post.isInsert && (disabledFilter || isDateInRange(post.createdAt)));
  };

  const filterClicks = (clicks: StatisticsClickType[]) => {
    return clicks.filter((click) => disabledFilter || isDateInRange(click.createdAt));
  };

  channels.forEach(({ participants, posts = [], clicks = [], sell }) => {
    totalParticipants += participants;

    totalPosts += (posts || []).length;

    const filteredPosts = filterPosts(posts || []);
    totalPostsWithBanner += filteredPosts.length;

    totalClicks += filterClicks(clicks).length;

    totalViews += filteredPosts.reduce((acc, post) => {
      if (!post.views) return acc;

      const viewsToConsider = disabledFilter
        ? post.views[post.views.length - 1]
        : post.views.find((view) => isDateInRange(view.date));

      return acc + (viewsToConsider?.views || 0);
    }, 0);

    totalSell += sell;
  });

  const clickPercentage = totalParticipants && totalClicks ? (totalClicks / totalParticipants) * 100 : 0;
  const bannerViewPercentage = totalParticipants ? (totalViews / totalParticipants) * 100 : 0;
  const cpcClicks = totalClicks ? totalSell / totalClicks : 0;
  const cpmViews = totalViews ? totalSell / (totalViews / 1000) : 0;

  return {
    totalParticipants,
    totalClicks,
    totalPostsWithBanner,
    totalChannels: channels.length,
    totalPosts,
    totalViews,
    clickPercentage,
    bannerViewPercentage,
    cpcClicks,
    cpmViews,
  };
};
